import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

import currentDomain, { SiteDomain, isPartnerDomain } from '../../../lib/currentDomain'
import { LandingPageLayout } from '../../../lib/landing-page-layout'
import { SignInForm } from '../../components/sign-in-form'
import { PartnerSignInInfoBlock } from '../../../partner/components/partner-sign-in-info-block'

export type LandingPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export function SignInPage({ className, style }: LandingPageProps): React.ReactElement {
    return (
        <div className="flex flex-column w-full">
            <LandingPageLayout className={cn(className)} style={style} dark={currentDomain === SiteDomain.SUPPORT}>
                <SignInForm />
            </LandingPageLayout>
            {isPartnerDomain && <PartnerSignInInfoBlock />}
        </div>
    )
}
